import { useTranslate } from "@refinedev/core";
import {
  ConfigProvider,
  Flex,
  Segmented,
  SegmentedProps,
  Typography,
} from "antd";

const OPTION_PADDING = 7;
const CONTAINER_PADDING = 4;

type OptionType<T extends string | boolean> = {
  value: T;
  icon?: React.ReactNode;
  label?: string;
};

type CustomSegmentedProps<T extends string | boolean> = Omit<
  SegmentedProps<T>,
  "options"
> & {
  customOptions: OptionType<T>[];
  textOnly?: boolean;
};

export const CustomSegmented = <T extends string | boolean>({
  value,
  onChange,
  customOptions,
  textOnly = false,
  ...rest
}: CustomSegmentedProps<T>) => {
  const t = useTranslate();
  return (
    <ConfigProvider
      theme={{
        components: {
          Segmented: {
            trackPadding: 4,
          },
          Typography: {
            fontSize: 12,
          },
        },
      }}
    >
      <Segmented
        value={value}
        onChange={(value) => {
          onChange?.(value);
        }}
        size="small"
        options={customOptions.map((option) => ({
          value: option.value,
          label: (
            <Flex
              vertical
              align="center"
              style={{ minWidth: 170 / customOptions.length }}
            >
              {option.icon}
              <Typography.Text
                style={{
                  fontWeight: option.value === value ? 500 : undefined,
                }}
              >
                {option.label
                  ? option.label
                  : t(`components.templates.settings.${option.value}`)}
              </Typography.Text>
            </Flex>
          ),
        }))}
        style={{
          width:
            170 +
            OPTION_PADDING * 2 * customOptions.length +
            CONTAINER_PADDING * 2,
        }}
        {...rest}
      />
    </ConfigProvider>
  );
};
